import script from "./RecensementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RecensementModal.vue?vue&type=script&setup=true&lang=js"

import "./RecensementModal.vue?vue&type=style&index=0&id=2be0a279&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be0a279"]])

export default __exports__